import app from '../../forum/app';
import Component from '../../common/Component';
import Link from '../../common/components/Link';
import username from '../../common/helpers/username';
import userOnline from '../../common/helpers/userOnline';
import listItems from '../../common/helpers/listItems';
import Avatar from '../../common/components/Avatar';
import ItemList from '../../common/utils/ItemList';
/**
 * The `PostUser` component shows the avatar and username of a post's author.
 */
export default class PostUser extends Component {
  view() {
    const post = this.attrs.post;
    const user = post.user();
    const items = user ? this.userViewItems(user, post) : this.noUserViewItems(user, post);
    return m("div", {
      className: "PostUser"
    }, items.toArray());
  }
  headingTag() {
    return this.attrs.headingLevel === 3 ? 'h3' : 'h2';
  }
  noUserViewItems(user, post) {
    const items = new ItemList();
    const Heading = this.headingTag();
    items.add('postUser-name', m(Heading, {
      className: "PostUser-name"
    }, m(Avatar, {
      user: user,
      className: "Post-avatar"
    }), " ", username(user)), 100);
    return items;
  }
  userViewItems(user, post) {
    const items = new ItemList();
    const Heading = this.headingTag();
    items.add('postUser-name', m(Heading, {
      className: "PostUser-name"
    }, m(Link, {
      href: app.route.user(user)
    }, this.linkChildren(user).toArray())), 100);
    items.add('postUser-badges', m("ul", {
      className: "PostUser-badges badges badges--packed"
    }, listItems(user.badges().toArray())), 90);
    return items;
  }
  linkChildren(user) {
    const items = new ItemList();
    items.add('avatar', m(Avatar, {
      user: user,
      className: "Post-avatar"
    }), 100);
    const onlineIndicator = userOnline(user);
    if (onlineIndicator !== null) {
      items.add('userOnline', onlineIndicator, 90);
    }
    items.add('username', username(user), 80);
    return items;
  }
}
flarum.reg.add('core', 'forum/components/PostUser', PostUser);